module.exports = __webpack_public_path__ + "images/180_2048.jpg";